import React from 'react';
import "./style.less";

interface Props {
    filterStatus: string;
    setFilterStatus: React.Dispatch<React.SetStateAction<string>>;
    totalOpenOrders: number;
    totalClosedOrders: number;
    totalInProgressOrders: number;
    isLoading?: boolean;
    setPageNo: React.Dispatch<React.SetStateAction<number>>;
}

const StatusFilters = ({ filterStatus, setFilterStatus, totalOpenOrders = 0, totalClosedOrders = 0, totalInProgressOrders = 0, isLoading, setPageNo }: Props) => {

    const statusList = [{
        value: "",
        dotClass: "dot-open",
        text: "All",
        count: totalOpenOrders + totalClosedOrders + totalInProgressOrders,
    },
    {
        value: "Open",
        dotClass: "dot-open",
        text: "Open",
        count: totalOpenOrders,
    },
    {
        value: "Accepted",
        dotClass: "dot-progress",
        text: "In Progress",
        count: totalInProgressOrders,
    },
    {
        value: "Closed",
        dotClass: "dot-closed",
        text: "Closed",
        count: totalClosedOrders,
    }];

    const handleFilterChange = (filter: string) => {
        setPageNo(1);
        if (filter === "") {
            setFilterStatus("");
            return;
        }
        if (filterStatus === filter) // If you click on the same filter again, it will deselect it
            setFilterStatus("");
        else
            setFilterStatus(filter);
    };
    return (
        <div className="status-tabs">
            {statusList.map((status) => {
                const isActive = filterStatus === status.value;
                return (
                    <button
                        key={status.value || 'all'}
                        type="button"
                        disabled={isLoading}
                        className={`status-tab ${status.dotClass}${isActive ? ' active' : ''}`}
                        onClick={() => handleFilterChange(status.value)}
                    >
                        {status.value && <span className="dot" />}
                        <span className="label">{status.text}</span>
                        <span className="count">{status.count}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default StatusFilters;
